import React from "react";
import "./card-content.scss";

function CardContent(props) {
  return <div className="callout-flex-content">{props.children}</div>;
}

export default CardContent;
